import { ICustomerInformationAndDeclaration } from './types';

export const customerInformationAndDeclaration: ICustomerInformationAndDeclaration = {
  title: 'HPP and BTL Customer Declaration',
  subTitle: [
    '<b>Please note if this Declaration is not signed / agreed to by or, if applicable, on behalf of all Home Purchase Plan (HPP) or Buy-To-let Purchase Plan (BTLPP) applicants and returned to us, we will not be able to progress your application.</b>',
    '<b>"I,"</b>, <b>"You"</b>, <b>"Your"</b>, <b>"My"</b>, <b>"We,"</b> <b>"Us,"</b> or <b>"Our"</b> means the applicant(s) under this agreement, and, where applicable, their Directors and Shareholders. In the event that there are multiple applicants, the terms "I,", "You", "Your" "My", "We," "Us," or "Our" shall include each applicant individually and collectively.',
    '<b>"Agreement"</b> means the Home Purchase Plan (HPP) or Buy-to-Let Purchase Plan (BTLPP) agreement that you enter into with StrideUp, including all associated terms, conditions, and schedules as may be amended from time to time.',
    '<b><u>For your benefit and protection, please read the following declarations carefully and ensure you understand them. If anything is unclear and you need further clarification, contact our team or seek independent advice before agreeing to this Declaration.</u></b>',
    '<b>StrideUp Homes Limited</b>, trading as StrideUp ("<b>StrideUp</b>") is registered as a data controller with the Information Commissioner under registration number <b>ZA337545</b>. StrideUp will assess the information that you have provided on your application, and any supporting documentation you provide for evidence of income/expenditure, in order to decide whether or not to enter into an Agreement with you.',
    '<b><u>By acknowledging this Declaration, the following statements are confirmed as true (each applicant on the application will be required to acknowledge this Declaration).</u></b>',
  ],
  sections: [
    {
      title: 'I/We agree that:',
      hasOrder: true,
      isListOrder: true,
      paragraphs: [
        {
          text: 'I/We believe the information given in my/our application is correct. I/We have personally completed our application, or if it was completed by someone else have read and checked every answer.',
        },
        {
          text: 'I/We will notify StrideUp of any changes in circumstances relating to my/our purchase before it is entered into, and I/We authorise My/Our Conveyancer/Broker/ Intermediary to disclose such information to you.',
        },
        {
          text: 'I/We will be jointly and severally liable for the finance provided by StrideUp.',
        },
        {
          text: '<b>APPLICABLE TO HPP ONLY</b> - I/We will personally occupy the property.',
        },
        {
          text: '<b>APPLICABLE TO BTLPP ONLY</b> - I/We, nor any member of our family*, will personally occupy the property at any point during the term of the BTLPP.',
        },
        {
          text: 'If a Limited Company, I confirm that the property will not be occupied by a Director, Shareholder, or any member of their family*.',
        },
        {
          style: ['italic', 'list-none'],
          text: '*Family includes but is not limited to spouse, civil partner, parent, sibling, child, grandparent, or grandchild.',
        },
      ],
    },
    {
      title: 'I/We understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'Any upfront fee that You are asked to pay to StrideUp is <b>non-refundable</b>. This means that if the application does not proceed for any reason, You will be unable to recover the fee.',
        },
        {
          text: 'Examples of why StrideUp might refuse Your application include, but are not limited to:',
          hasSubParagraphsOrder: true,
          isSubParagraphsListOrder: true,
          subParagraphs: [
            'where it has not been possible to verify Your declared income;',
            'where it is discovered that You, or any joint applicant has provided false or incomplete information;',
            'where it is discovered that a problem with the property You wish to purchase makes it unsuitable as security;',
            'where a property assessment reveals that the property is worth less than You originally indicated or and;',
            'where StrideUp has a reasonable suspicion of fraud and/or other forms of financial crime',
          ],
        },
      ],
    },
    {
      title: 'I/We understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'StrideUp may share Your personal information with Your employer(s), landlord, accountant, banker, Directors (if applicable), current and previous lenders, and HMRC in order to request information from them.',
        },
        {
          text: 'The importance of ensuring that the information provided in the application, and any supporting documentation is correct. If any information given is incorrect or misleading, StrideUp may withdraw the HPP/BTL Offer, demand repayment or make reasonable changes to the Agreement.',
        },
      ],
    },
    {
      title: 'I/We agree that:',
      hasOrder: true,
      isListOrder: true,
      paragraphs: [
        {
          text: 'StrideUp will assess the information that I/We have provided on the application and any supporting documentation, in order to decide whether or not to enter into a HPP/BTLPP with Me/Us.',
        },
        {
          text: "You will notify StrideUp of any changes, which have, or are likely to have, an effect on the continuing accuracy of the information declared in the application, and supporting documentation, which may affect StrideUp's ability to enter into an Agreement with You;",
        },
        {
          text: 'Any solicitor acting for me may disclose to StrideUp any information or documentation that StrideUp may ask for about the Agreement or property which is the subject of this application, and You waive any duty of confidentiality or privilege which may otherwise exist in relation to this Agreement; and,',
        },
        {
          text: 'StrideUp may provide information to an insurer to assess the risk of providing related insurance or to assess the risk of default.',
        },
      ],
    },
    {
      title: 'I/We understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'Throughout the application process, StrideUp will ensure all income and expenditure is validated/reasonable. This may be by utilising ONS (Office of National Statistics) figures, requesting additional bank statements and may also include the running of credit checks periodically through the lifecycle of the application. This will ensure that as a responsible lender, StrideUp will have reviewed and assessed all expenditure correctly to gauge affordability.',
        },
      ],
    },
    {
      title: 'I/We agree that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'StrideUp may provide any information contained in this application (and all information associated with this application) to any originator, financial advisor, financier, accountant, Credit Reference Agencies (CRA), Fraud Prevention Agencies (FPA), legal practitioners or third parties involved with the Agreement to be entered into with Me/Us, or as deemed appropriate by StrideUp in its sole discretion.',
        },
      ],
    },
    {
      title: 'I/We agree that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'StrideUp may disclose any personal information or report about You to any organisation, which may be required for any form of securitisation of any financing, sale of notes or other form of transfer of the Agreement, which may be provided.',
        },
      ],
    },
    {
      title: 'I/We acknowledge and understand that:',
      hasOrder: true,
      isListOrder: true,
      paragraphs: [
        {
          text: "All payments will be made by Direct Debit from a UK-based bank account, from the applicant's bank account, unless otherwise agreed with StrideUp.",
        },
        {
          text: 'The amount that is paid each month, or the date that the monthly payment is made, may change, and that in either case, StrideUp will give notice in writing before this happens. On this basis, You waive the normal fourteen days BACS notice.',
        },
      ],
    },
    {
      title: 'I/We acknowledge that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'Any telephone calls, emails relating to the application may be recorded and monitored for security, quality and/or training purposes.',
        },
      ],
    },
    {
      title: 'I/We understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'StrideUp may decide to decline the application if You do not meet the criteria, and that StrideUp can withdraw any HPP/BTLPP Offer without providing reasons to me. You also understand that StrideUp may reject the application at any time at its absolute discretion.',
        },
        {
          text: "If the application is rejected, any fees paid upfront will be non-refundable (see StrideUp's Tariff List).",
        },
      ],
    },
    {
      title: 'I/We acknowledge & understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'There is an obligation on You to purchase the remaining share of the property during or at the end of the term, this can include making additional payments. You will have a suitable strategy in place to buy the remaining share of the property by the end of the term.',
        },
      ],
    },
    {
      title: 'I/We understand that:',
      hasOrder: false,
      paragraphs: [
        {
          text: 'If You cannot meet your obligation to purchase the remaining share, You may have to sell the property at the end of the term. You acknowledge that you should carefully consider how this may affect our personal circumstances.',
        },
      ],
    },
    {
      title: 'For Joint Applications I/We acknowledge:',
      hasOrder: true,
      isListOrder: true,
      paragraphs: [
        {
          text: 'We authorise StrideUp to send only one statement for each account;',
        },
        {
          text: 'We agree that a credit search will be made on each applicant, and if applicable, on the entity and its directors.; and,',
        },
        {
          text: 'Where You hold an account in joint names StrideUp shall be entitled to accept the signature, instruction or authority of either of You, unless You advise StrideUp otherwise.',
        },
      ],
    },
    {
      title: 'FOR BTL ONLY',
      hasOrder: false,
      paragraphs: [
        {
          text: "StrideUp's Buy-to-Let (BTL) purchase plans are not regulated by the Financial Conduct Authority (FCA). As a result, they are not covered by the Financial Ombudsman Service (FOS) or the Financial Services Compensation Scheme (FSCS).",
        },
      ],
    },
  ],
  afterwards: [
    {
      title: 'Fair Processing Notice and Data Sharing Principles',
      subTitle: [
        'Below is a short-form explanation of the use of your personal data by Credit Reference and Fraud Prevention Agencies.',
        'When you apply to StrideUp for a HPP/ BTLPP before providing services and goods, StrideUp will check the following records about you and anyone else applying with you:',
      ],
      hasOrder: false,
      paragraphs: [
        {
          text: "information held on StrideUp's own systems;",
        },
        {
          text: 'information held by Credit Reference Agencies (CRAs), including Equifax, may be shared with StrideUp. When CRAs receive a search request from StrideUp, they will place a search footprint on your credit file, which may be visible to other lenders. They provide StrideUp with both public information (including the electoral register) and shared credit and fraud prevention data; and',
        },
        { text: 'those held by Fraud Prevention Agencies (FPA), including CIFAS.' },
      ],
    },
    {
      subTitle: [
        'StrideUp will undertake searches as part of the assessment of the application for a HPP/BTLPP and verifying identities to prevent and detect crime and money laundering. StrideUp may also register information about you and the conduct of your account with CRAs and FPAs and make periodic searches at CRAs and FPAs to manage your account.',
        'We will use this information to:',
      ],
      hasOrder: false,
      paragraphs: [
        { text: 'Assess your creditworthiness and whether you can afford to take the product;' },
        { text: 'Verify the accuracy of the data you have provided to us;' },
        { text: 'Prevent criminal activity, e.g. fraud and money laundering;' },
        { text: 'Manage your account(s);' },
        { text: 'Trace and recover any debts; and' },
        { text: 'Ensure any offers provided to you are appropriate to your circumstances.' },
      ],
    },
    {
      subTitle: [
        'Information exchanged with CRAs and FPAs will include information provided on your application, name, address, date of birth, public information etc. We share this information to confirm identities and help prevent fraud and money laundering. If we or an FPA decide there is a risk of fraud, we may stop activity on the account or block access. FPAs will also keep a record of the risk you or your business pose.',
        "If you are making a joint application, or tell us that you have a spouse or a financial associate, we will link your records together, so you should make sure you discuss this with them, and share with them this information, before lodging the application. CRA's will also link your records together and these links will remain on your and their files until such time as your partner successfully files for a disassociation with the CRA's to break the link. You must share StrideUp's Privacy Policy with them to help explain how their data may be used and protected.",
        "If you provide information during the course of your application relating to a Giftor, you must ensure that you have their explicit consent to share their personal and financial information. This includes, but is not limited to, their identity details, the amount of the gift, and the source of funds. StrideUp may undertake verification checks on the Giftor, and their information may be shared with credit reference agencies or third parties for the purposes of fraud prevention and regulatory compliance. It is your responsibility to make the Giftor aware of this and obtain their agreement in advance. You must share StrideUp's Privacy Policy with them to help explain how their data may be used and protected.",
        'We will continue to share information about you with CRAs for as long as you have a relationship with us. We will also notify the CRAs when your accounts are settled. If you borrow and fail to repay in full or on time, the outstanding debt will be recorded by the CRAs. This information may then be shared with other organisations. Details from your application may also be provided to CRAs and FPAs to carry out similar checks, trace your whereabouts, and recover any debts you owe. Records will remain on file for six years after an account is closed, whether it is settled or marked as defaulted.',
        'StrideUp may make searches of records at FPAs who may provide StrideUp with information about other applications made and any data recorded, and they will record information about your application so that other users of the FPAs may use the information in making their decisions.',
        'If you give StrideUp false or inaccurate information and StrideUp suspects identify fraud, it will be recorded by StrideUp and may also be passed on to FPAs and other organisations involved in crime and fraud prevention.',
        'StrideUp and other organisations may access and use from other countries the information recorded by FPAs.',
        'The main CRAs and FPAs operating in the UK are listed below. You can contact them to get the information they hold about you using the details given below. The information they hold may not be the same, so it is worth contacting them all.',
        'If you are providing a personal guarantee as a director of an SPV, please note that your credit file may be impacted as a result of missed payments.',
      ],
      hasOrder: false,
      paragraphs: [],
    },
    {
      title: 'CREDIT REFERENCE AGENCIES',
      hasOrder: false,
      paragraphs: [
        {
          text: 'TRANSUNION: Consumer Services Team, PO Box 491, Leeds, LS3 1WZ or call 0870 060 1414 or log on to <a href="https://transunion.co.uk" target="_blank">transunion.co.uk</a>',
        },
        {
          text: 'EQUIFAX: Credit File Advice Centre, PO Box 3001, Bradford, BD1 5US or call 0870 010 0583 or log on to <a href="https://my.equifax.co.uk" target="_blank">my.equifax.co.uk</a>',
        },
        {
          text: 'EXPERIAN: Consumer Help Service, PO Box 8000, Nottingham NG80 7WF or call 0844 481 8000 or log on to <a href="https://experian.co.uk" target="_blank">experian.co.uk</a>',
        },
      ],
    },
    {
      title: 'FRAUD PREVENTION AGENCIES',
      hasOrder: false,
      paragraphs: [
        {
          text: 'CIFAS: Cifas 6th Floor, Lynton House, 7 - 12 Tavistock Square London WC1H 9LT or log on to <a href="https://www.cifas.org.uk/individuals" target="_blank">cifas.org.uk/individuals</a>',
        },
        {
          text: "National Hunter: One St Peter's Square, Manchester, United Kingdom, M2 3DE or log on to <a href='https://nhunter.co.uk/' target='_blank'>nhunter.co.uk/</a>",
        },
        {
          text: 'Synectics Solutions: Hamil Road, Burslem, Stoke-on-Trent, ST6 1AJ or log on to <a href="https://www.synectics-solutions.com/" target="_blank">synectics-solutions.com/</a>',
        },
      ],
    },
    {
      subTitle: [
        "The identities of the CRA's, their role also as fraud prevention agencies, the data they hold, the ways in which they use and share personal information, data retention periods and your data protection rights with the CRA's are explained in more detail at <a href='https://equifax.co.uk/crain' target='_blank'>https://equifax.co.uk/crain</a>, <a href='https://experian.co.uk/legal/crain' target='_blank'>experian.co.uk/legal/crain</a> and <a href='https://transunion.co.uk/legal/privacy-centre/pc-credit-reference' target='_blank'>transunion.co.uk/legal/privacy-centre/pc-credit-reference</a>.",
        "StrideUp's Privacy Policy and the law regarding your personal information is available at <a href='https://strideup.co/privacy-policy' target='_blank'>strideup.co/privacy-policy</a>.",
        'StrideUp may be required by law, or as a consequence of any contractual relationship, to collect certain personal information. Failure to provide this information may prevent or delay StrideUp fulfilling these obligations or performing their services.',
        'The law gives you a number of rights in relation to your personal information including:',
      ],
      hasOrder: false,
      paragraphs: [
        {
          text: 'the right to access the personal information StrideUp holds about you. This includes information from enquiry forms, statements, correspondence and call recordings.',
        },
        { text: 'the right to get StrideUp to correct personal information that is wrong or incomplete.' },
        {
          text: 'in certain circumstances, the right to ask StrideUp to stop using or delete your personal information.',
        },
        {
          text: "You have the right to receive any personal information StrideUp has collected from you in an easily re-usable format when it's processed on certain grounds, such as consent or for contractual reasons. You can also ask StrideUp to pass this information on to another organisation.",
        },
      ],
    },
    {
      subTitle: [
        "You can find out more about these rights and how you can exercise them in StrideUp's Privacy Policy at <a href='https://strideup.co/privacy-policy' target='_blank'>strideup.co/privacy-policy</a>.",
        'To obtain the records StrideUp holds about you/or to amend inaccurate details, please write to: Data Protection Officer, Strideup Homes Limited Third Floor, 20 Old Bailey, London, EC4M 7AN or email StrideUp at hello@strideup.co.',
        '<i>The personal information StrideUp has collected from you will be shared with fraud prevention agencies who will use it to prevent fraud and money-laundering and to verify your identity. If fraud is detected, you could be refused certain services, finance, or employment. Further details of how your information will be used by us and these fraud prevention agencies, and your data protection rights, can be found by visiting <a href="https://cifas.org.uk" target="_blank">https://cifas.org.uk</a></i>',
      ],
      hasOrder: false,
      paragraphs: [],
    },
    {
      title: 'Consent and Marketing Preferences',
      subTitle: [
        "By proceeding, I/We confirm that I/we have read and understood StrideUp's Privacy Policy and consent to the collection, use, and sharing of my/our personal information as described therein.",
      ],
      hasOrder: false,
      paragraphs: [],
    },
  ],
  warning: [
    'YOUR HOME OR BUY-TO-LET PROPERTY MAY BE REPOSSESSED OR A RECEIVER OF RENT MAY BE APPOINTED IF YOU DO NOT KEEP UP THE PAYMENTS ON YOUR BUY TO LET PURCHASE PLAN.',
    'Buy to let Purchase Plans are not regulated by the Financial Conduct Authority.',
  ],
  footer: [
    'StrideUp Homes Limited is a trading name of StrideUp Homes Limited, authorised and regulated by the Financial Conduct Authority (785299). Registered in England and Wales with company number 10848518. Registered office: Third Floor, 20 Old Bailey, London, United Kingdom, EC4M 7AN.',
  ],
};
